export const SPOTLIGHT_LAYOUT_CENTERED = 'centered';
export const SPOTLIGHT_LAYOUT_PIN_RIGHT = 'pin-right';
export const SPOTLIGHT_LAYOUT_PIN_LEFT = 'pin-left';
export const SPOTLIGHT_LAYOUT_FLOATING = 'floating';